import * as React from "react";
import "./App.css";
import Main from "./Main";
import FooterV2 from "./FooterV2";
import Nav from "./Nav";  

function App() {

  return (
    <>
      <Main />
    </>
  );
}

export default App;
